import _ from 'lodash'

export function secondsToTimeString(
  value: number | undefined,
  trimMS: boolean = false
): string | undefined {
  if (value === undefined) return
  value = value || 0
  const d = new Date(0)
  d.setSeconds(_.floor(value), (value % 1) * 1000)
  const h = d.getUTCHours()
  const m = d.getUTCMinutes()
  const s = d.getUTCSeconds() + (trimMS ? 0 : d.getUTCMilliseconds() / 1000)
  const components: number[] = []
  if (h) components.push(h)
  if (m || components.length > 0) components.push(m)
  components.push(s)
  return _.chain(components)
    .map((v, i) => {
      const _res = v.toFixed(2).padStart(5, '0')
      if ((i === components.length - 1 && trimMS) || i < components.length - 1) {
        if (_.endsWith(_res, '.00')) return _res.substring(0, _res.length - 3)
      }
      return _res
    })
    .join(':')
    .value()
}

export function timeStringToSeconds(value: string | undefined): number | undefined {
  if (!value) return
  let _res: number | undefined
  if (/:/.test(value)) {
    const _parts = _.chain(value).split(':').map(_.toNumber).filter(_.isNumber).value()
    if (_parts.length <= 3) {
      _res = _.chain(_parts)
        .reverse()
        .map((v, i) => {
          return v * 60 ** i
        })
        .reduce((prev, curr) => _.sum([prev || 0, curr]))
        .value()
    }
  } else _res = _.toNumber(value)
  if (_.isNaN(_res)) return
  if (!_.isNumber(_res)) return
  return _res
}
